/// <amd-module name="VC/Common/Components/RepositoryDropdown" />
import * as React from "react";

import { css } from "VSSUI/Util";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ItemPickerDropdown } from "VSSUI/PickList";

import { RepositoryPickerProvider } from "../RepositoryPickerProvider";
import { IRepositoryPickListProps } from "./RepositoryPicker.Props";

export class RepositoryDropdownComponent extends VssComponent<IRepositoryPickListProps, {}> {
    private pickerProvider: RepositoryPickerProvider;
    private itemPicker = React.createRef<ItemPickerDropdown>();

    public constructor(props: IRepositoryPickListProps, context: IVssComponentContext) {
        super(props, context);

        this.pickerProvider = new RepositoryPickerProvider(context.pageContext, props.providerOptions);
    }

    public render(): JSX.Element | null {
        const { className, tabIndex, hideSelectedItemIcon, dropdownIconProps, isOpen, onToggleDropdown, ariaDescribedBy, onFocus, onFocusLost } = this.props;

        return (
            <ItemPickerDropdown
                ref={this.itemPicker}
                id={this.props.id}
                provider={this.pickerProvider}
                className={css("repository-selector", className)}
                tabIndex={tabIndex}
                pickListClassName="repository-selector-dropdown"
                hideSelectedItemIcon={hideSelectedItemIcon}
                dropdownIconProps={dropdownIconProps}
                ariaDescribedBy={ariaDescribedBy}
                isOpen={isOpen}
                onToggleDropdown={onToggleDropdown}
                onFocus={onFocus}
                onFocusLost={onFocusLost}
            />
        );
    }

    public componentDidMount(): void {
        super.componentDidMount();

        if (this.props.componentRef) {
            this.props.componentRef(this);
        }
    }
    
    public componentWillReceiveProps(nextProps: IRepositoryPickListProps): void {
        if (nextProps.providerOptions !== this.props.providerOptions) {
            this.pickerProvider = new RepositoryPickerProvider(this.context.pageContext, nextProps.providerOptions);
        }
    }

    public focus(): void {
        if (this.itemPicker.current) {
            this.itemPicker.current.focus();
        }
    }
}
